import { segmentHit3d } from '../../../../ft3d/engine/ft3d-shape-core.js';
import type { RestShape } from '../inventory/floor-move.js';
import type { Point } from './forced-movement.js';

const EPS = 1e-6;

/** Stop the path at structural contact, keeping the body's footprint before the wall face. */
export function wallStop(shape: RestShape, start: Point, end: Point, base: number, height: number): { end: Point; wallContact: boolean } {
  const wall = segmentHit3d(shape as never, { ...start, z: start.z + height / 2 }, { ...end, z: end.z + height / 2 }, { mode: 'move' });
  let wallFraction = 1;
  if (wall) {
    const axis = wall.axis as 'x' | 'y';
    wallFraction = Math.max(0, wall.t - (base / 2 + EPS) / Math.abs(end[axis] - start[axis]));
  }
  // The leading footprint can contact a face before the centre reaches it. The small probe margin
  // also includes endpoint contact, which segmentHit3d deliberately omits for ordinary sight rays.
  for (const axis of ['x', 'y'] as const) {
    const delta = end[axis] - start[axis];
    if (Math.abs(delta) < EPS) continue;
    const offset = Math.sign(delta) * (base / 2 + .01);
    const hit = segmentHit3d(shape as never,
      { ...start, [axis]: start[axis] + offset, z: start.z + height / 2 },
      { ...end, [axis]: end[axis] + offset, z: end.z + height / 2 }, { mode: 'move' });
    if (hit?.axis === axis) wallFraction = Math.max(0, Math.min(wallFraction, hit.t + (.01 - EPS) / Math.abs(delta)));
  }
  const wallContact = wallFraction < 1;
  if (wallContact) end = { x: start.x + (end.x - start.x) * wallFraction, y: start.y + (end.y - start.y) * wallFraction,
    z: start.z + (end.z - start.z) * wallFraction };
  return { end, wallContact };
}
